import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PinVerificationState {
  isVerified: boolean;
}

const initialState: PinVerificationState = {
  isVerified: false,
};

const pinVerificationSlice = createSlice({
  name: 'pinVerification',
  initialState,
  reducers: {
    verifyPin: (state) => {
      state.isVerified = true;
    },
    clearPinVerification: (state) => {
      state.isVerified = false;
    },
  },
});

export const { verifyPin, clearPinVerification } = pinVerificationSlice.actions;
export default pinVerificationSlice.reducer;
